<template>
    <div class="container py-3">

        <div class="row">
            <div class="col-lg-3 col-md-5 col-sm-12">
                <NavBarJob :jobParent="jobId"/>
            </div>
            <div class="col-lg-9 col-md-7 col-sm-12 mt-3 pt-4">
                <router-view></router-view>
            </div>
        </div>

    </div>
</template>
<script>
import NavBarJob from './components/NavBarJob'

export default {
    components: {
        'NavBarJob': NavBarJob
    },
    data() {
        return {
            jobId: {}
        }
    },
    methods: {
        loadJobFromId(id) {
            this.api.get('enterprise/job/find/' + id).then(({data}) => {
                if (data.body) {
                    this.jobId = data.body
                }
            }).catch(err => {
                console.log(err)
            })
        }
    },
    watch: {
        JobId: function (val) {
        }
    },
    created() {
        let id = this.$route.params.id
        if (id != undefined) {
            this.loadJobFromId(id)
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/jobs/Generate.vue